var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Styled } from './style';
var SyncStateText = /** @class */ (function (_super) {
    __extends(SyncStateText, _super);
    function SyncStateText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SyncStateText.prototype.render = function () {
        var _a = this.props, isDraftSaving = _a.isDraftSaving, savingText = _a.savingText, savedText = _a.savedText;
        return (React.createElement(Styled, { fadeOut: isDraftSaving === false, className: this.props.className },
            React.createElement("p", null, isDraftSaving ? savingText : isDraftSaving === null ? null : savedText)));
    };
    SyncStateText.defaultProps = {
        savingText: 'Saving ...',
        savedText: 'Draft saved',
    };
    return SyncStateText;
}(React.Component));
export default SyncStateText;
//# sourceMappingURL=index.js.map